module.exports = __webpack_public_path__ + "static/media/panel-diety-icon.68a78a63.svg";